import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.function.name.js";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { simpleEmojis } from "@/common/emojis";
import { SIMPLE_EMOJI_KEYS_WITH_ORDER } from "@/common/emojiPathMap";
import { Emoji } from "@/assets/sprites/emoji";
var simpleEmojiClassesWithOrder = SIMPLE_EMOJI_KEYS_WITH_ORDER.map(function (e) {
  return Emoji[e];
});
var res = Object.values(simpleEmojis);
var sortedEmojis = res.sort(function (e) {
  return simpleEmojiClassesWithOrder.indexOf(e.iconClass);
});

var ChatInputEmojiBox =
/** @class */
function (_super) {
  __extends(ChatInputEmojiBox, _super);

  function ChatInputEmojiBox(props) {
    var _this = _super.call(this, props) || this;

    _this.onContainerClicked = function (e) {
      e.stopPropagation();
    };

    _this.state = {
      currentEmojiTab: "simple"
    };
    return _this;
  }

  ChatInputEmojiBox.prototype.shouldComponentUpdate = function (nextProp, nextState) {
    return nextState.currentEmojiTab !== this.state.currentEmojiTab;
  };

  ChatInputEmojiBox.prototype.render = function () {
    var _this = this;

    return _jsx("div", __assign({
      className: "chat-input-area__emojis-container",
      onClick: this.onContainerClicked
    }, {
      children: this.state.currentEmojiTab === "simple" && _jsx("ul", __assign({
        className: "chat-input-area__simple-emojis custom-scroll-bar"
      }, {
        children: sortedEmojis.map(function (emoji) {
          var kls = "icon " + emoji.iconClass;
          return _jsx("li", __assign({
            onClick: function onClick(e) {
              e.preventDefault();
              e.stopPropagation();

              _this.props.onSimpleEmojiClicked(emoji);
            }
          }, {
            children: _jsx("span", {
              className: kls
            }, void 0)
          }), emoji.name);
        })
      }), void 0)
    }), void 0);
  };

  return ChatInputEmojiBox;
}(React.Component);

export default ChatInputEmojiBox;